<template>
    <div>
        <v-dialog
                v-model="showDialog"
                persistent
                width="100%"
                max-width="500"
        >
            <v-card>
                <v-card-title>
                    {{text}}
                </v-card-title>

                <v-card-actions>
                    <v-spacer></v-spacer>



                    <v-btn
                            class="btn btn-primary "
                            text
                            @click="$emit('close-dialog', true, activatorId)"
                    >
                        {{$t('sammio.yes')}}
                    </v-btn>

                  <v-btn
                      text
                      class="btn btn-default"
                      @click="$emit('close-dialog', false, activatorId)"
                  >
                    {{$t('sammio.no')}}
                  </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>

    export default {
        name: "SammioDialog",
        props: {
            text: String,
            showDialog: Boolean,
            activatorId: String
        }
    }
</script>

<style scoped>

</style>
